import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import request from 'Request'
import { ModalStore } from 'Store'

import Tab from '../components/Tab'
import Header from 'Components/Header'
import { Grid, Flex } from 'lese'
import Card from 'Components/Card'
import ModalCard from '../components/ModalCard'
import InfoTabs from '../components/InfoTabs'

import {
  faGripVertical,
  faMobile,
  faBuilding,
  faUser
} from '@fortawesome/free-solid-svg-icons'

export default () => {
  const showModalActivity = ({ isOffice, isPatient }) =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <ModalCard
          title="App"
          baseUrl="/activity/report"
          isOffice={isOffice}
          isPatient={isPatient}
          title={isOffice ? (isPatient ? 'Patient' : 'Office') : 'App'}
          icon={isOffice ? (isPatient ? faUser : faBuilding) : faMobile}
        />
      ]
    }))

  const showModalAlert = ({ isOffice, isPatient }) =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <ModalCard
          title="App"
          baseUrl="/alerts/report"
          isOffice={isOffice}
          isPatient={isPatient}
          color={colors.alert}
          title={isOffice ? (isPatient ? 'Patient' : 'Office') : 'App'}
          icon={isOffice ? (isPatient ? faUser : faBuilding) : faMobile}
        />
      ]
    }))

  const showModalDevice = ({ isOffice, isPatient }) =>
    ModalStore.set(state => ({
      components: [
        ...state.components,
        <ModalCard
          title="App"
          baseUrl="/device/report"
          isOffice={isOffice}
          isPatient={isPatient}
          color={colors.device}
          title={isOffice ? (isPatient ? 'Patient' : 'Office') : 'App'}
          icon={isOffice ? (isPatient ? faUser : faBuilding) : faMobile}
        />
      ]
    }))

  return (
    <>
      <InfoTabs />
      <Header>Report Tools</Header>
      <Grid columns="1fr 1fr 1fr" rows="1fr" gap="16px">
        <Flex xAlign column separation="16px">
          <h1 style={{ fontSize: '1.8em', color: colors.activity }}>
            Activity - Quick Report
          </h1>
          <Card title="App" onClick={showModalActivity} icon={faMobile}>
            <span>
              Create a billing report for app offerings in relation to client
              clusters.
            </span>
          </Card>
        </Flex>
        <Flex xAlign column separation="16px">
          <h1 style={{ fontSize: '1.8em', color: colors.device }}>
            Device - Quick Report
          </h1>
          <Card
            title="App"
            color={colors.device}
            onClick={showModalDevice}
            icon={faMobile}
          >
            <span>
              Create a billing report for app offerings in relation to client
              clusters.
            </span>
          </Card>
        </Flex>
        <Flex xAlign column separation="16px">
          <h1 style={{ fontSize: '1.8em', color: colors.alert }}>
            Alert - Quick Report
          </h1>
          <Card
            title="App"
            color={colors.alert}
            onClick={showModalAlert}
            icon={faMobile}
          >
            <span>
              Create a billing report for app offerings in relation to client
              clusters.
            </span>
          </Card>
        </Flex>
      </Grid>
    </>
  )
}
